"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeatmapConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var HEATMAP_TEMPLATE = {
    chart: {
        type: "heatmap",
        marginTop: 8,
        marginRight: 0,
        spacingRight: 0,
    },
    plotOptions: {
        heatmap: {
            dataLabels: {
                enabled: true,
                allowOverlap: false,
                crop: true,
                overflow: "justify",
            },
            point: {
                events: {
                    // from Highcharts 5.0.0 cursor can be set by using 'className' for individual data items
                    mouseOver: function () {
                        if (this.drilldown) {
                            this.graphic.element.style.cursor = "pointer";
                        }
                    },
                },
            },
        },
    },
    yAxis: [
        {
            labels: {
                formatter: function () {
                    var _a = this, axis = _a.axis, isLast = _a.isLast;
                    var tickPositions = axis.tickPositions, categories = axis.categories;
                    // tickPositions is array of index of categories
                    var lastIndex = parseInt(last_1.default(tickPositions).toString(), 10);
                    var lastCategory = categories ? categories[lastIndex] : null;
                    var labelValue = axis.defaultLabelFormatter.call(this);
                    // When generate linear tick positions base on categories length.
                    // Last tick position can be out of index of categories.
                    // In this case, set label value to null to ignore last label.
                    if (isLast && categories && !lastCategory) {
                        labelValue = null;
                    }
                    return labelValue;
                },
            },
        },
    ],
};
function getHeatmapConfiguration() {
    return cloneDeep_1.default(HEATMAP_TEMPLATE);
}
exports.getHeatmapConfiguration = getHeatmapConfiguration;
//# sourceMappingURL=heatmapConfiguration.js.map